























































import Vue from 'vue';
import { TaskServicesService } from '@/services/TaskServicesService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreMakeChangesLock from '@/components/shared/MStoreMakeChangesLock.vue';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Configuration, ConfigurationChangeModel, StoreConstants, TaskServiceModel } from '@/types';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'TaskServices',
  data() {
    return {
      isLoading: true,
      taskServices: [] as TaskServiceModel[],
      searchQuery: '',
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChange,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading
    ]),
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    lock(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock];
    },
    bypassLockingOnToolkit(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock];
    },
    isLockLoading(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading];
    },
    tableItems(this: any) {
      return (this.taskServices as TaskServiceModel[]).map(
        ({ name, description, serviceJobHosts, serviceQueueHosts, enabled, queueName }) => {
          const allServiceHosts = [...serviceJobHosts, ...serviceQueueHosts];
          const distinctServiceHosts = allServiceHosts
            .map((x) => x.hostName)
            .filter((value, index, self) => self.indexOf(value) === index);
          const serviceJobHostThreads = serviceJobHosts.map((x) => x.workers || 'Auto').join(', ');
          return {
            name,
            description,
            hosts: distinctServiceHosts.length,
            threads: serviceJobHostThreads,
            enabled: enabled ? 'Yes' : 'No',
            queueName
          };
        }
      );
    },
    buttonText(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession]
        ? 'Configure'
        : 'View';
    }
  },
  methods: {
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Actions.BeginChange,
      StoreConstants.ConfigurationChange.Actions.EndChange,
      StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage
    ]),
    configureService(serviceName: any) {
      this.$router.push({ name: Configuration.TaskServices.TaskServiceConfiguration.name, params: { serviceName } });
    },
    async onChangeReasonEntered(this: any, changeReason: string) {
      try {
        await this[StoreConstants.ConfigurationChange.Actions.BeginChange]({
          controllerPath: this.CHANGE_CONTROLLER_PATH,
          configurationChange: {
            description: changeReason
          } as ConfigurationChangeModel
        });
      } catch (error) {
        this.$log(error);
      }
    },
    async onReleaseLock(this: any) {
      await this[StoreConstants.ConfigurationChange.Actions.EndChange](this.CHANGE_CONTROLLER_PATH);
    },
    onClickGlobalConfiguration(this: any) {
      this.$router.push({ name: Configuration.TaskServices.TaskServicesGlobalConfiguration.name });
    }
  },
  async mounted(this: any) {
    this[StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage](this.CHANGE_CONTROLLER_PATH);
    this.taskServices = await TaskServicesService.getAllTaskServices();
    this.isLoading = false;
  },
  created(this: any) {
    this.TABLE_FIELDS = [
      { key: 'name', label: 'Name', sortable: true },
      { key: 'description', label: 'Description' },
      { key: 'hosts', label: 'Hosts' },
      { key: 'threads', label: 'Worker Threads' },
      { key: 'enabled', label: 'Enabled', sortable: true },
      { key: 'actions', label: '', class: 'action-element' }
    ] as BvTableFieldArray;
    this.CHANGE_CONTROLLER_PATH = 'taskServicesConfiguration';
  },
  components: {
    LoadingSpinner,
    MStoreTable,
    MStoreMakeChangesLock
  }
});
